import { formFieldErrorHtml, mergePreviewStyle, toRGBA, getFontFamily } from "../parser/utils";
import { getFormLableStyleStr } from "../FormText/FormBaseStyle";

export default ({ data, id, root }) => {
  const {
    label,
    hideLabel,
    rows,
    cols,
    required,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    optionsDefaultFont,
    optionsFontSize,
    optionsFontColor,
    labelDefaultFont,
    labelFontSize,
    labelFontColor,
    labelHorizonAlignment,    
  } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor,
  } = root.data;


  // 1. Get base styles string
  const baseLabelStyleStr = getFormLableStyleStr(data, root.data) || "";

  
  const overrideStyleParts = [];
  overrideStyleParts.push('display: flex');
  overrideStyleParts.push('align-items: flex-start');

  const finalLabelFontColor = labelFontColor || formTextColor;
  if (finalLabelFontColor) {
    overrideStyleParts.push(`color: ${toRGBA(finalLabelFontColor)}`);
  }
  if (labelDefaultFont) {
    overrideStyleParts.push(`font-family: ${labelDefaultFont}`);
  }
  const trimmedLabelFontSize = String(labelFontSize || "").trim();
  if (trimmedLabelFontSize && trimmedLabelFontSize !== '0') {
    overrideStyleParts.push(`font-size: ${trimmedLabelFontSize}px`);
  }
  overrideStyleParts.push(`justify-content: ${labelHorizonAlignment || "start"}`);

  // This string is what you consider your 'labelInlineStyle'
  const labelInlineStyleString = overrideStyleParts.join('; ');

  // 3. Use the merge function with the desired parameter name
  const finalLabelStyleStr = mergePreviewStyle(baseLabelStyleStr, labelInlineStyleString);

  const optionFontFamily = getFontFamily(
    optionsDefaultFont,
    root?.data?.defultFont
  );

  return `
    <div
      class="rip-field-group"
      style="
        text-align: left;
        padding-top: ${paddingTop}px;
        padding-bottom: ${paddingBottom}px;
        padding-right: ${paddingRight}px;
        padding-left: ${paddingLeft}px;
      "
    >
      <label
            for="${id}"
            class="rip-field-label"
                  style="${finalLabelStyleStr}; display: ${
        hideLabel ? "none" : "flex"
      };"
    "
          >
            ${
              required
                ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
                : ""
            }${label}
        </label>

      <div
        id="${id}"
        style="
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
        "
      >
        <table width="100%" style="text-align: left; border-collapse: collapse;">
          <tr style="
             height: 35px;
             color: ${toRGBA(formTextColor)};
             font-family: ${optionFontFamily};
             font-size: ${optionsFontSize}px;
           ">
            <th></th>
            ${cols.map(col => `<th style="color: ${toRGBA(optionsFontColor || formTextColor)};">${col.value}</th>`).join('')}
          </tr>
          <tbody>
            ${rows.map((row, rowIdx) => {
              const borderTop = `${formBorderWidth}px ${formBorderStyle} ${toRGBA(formBorderColor)}`;
              return `
              <tr style="
                height: 35px;
                border-top: ${borderTop};
                color: ${toRGBA(labelFontColor || formTextColor)};
              ">
                <td style="
                  padding: 0 8px;
                  margin-bottom: 0;
                  font-weight: normal;
                  color: ${toRGBA(optionsFontColor || formTextColor)};
                  font-family: ${optionFontFamily};
                  font-size: ${optionsFontSize}px;
                ">
                  ${row.label}
                </td>
                  ${cols.map((col, colIdx) => `
                  <td style="padding: 0 8px;">
                    <input
                      type="radio"
                      name="${id}-${rowIdx}"
                      id="${id}-${rowIdx}-${colIdx}"
                      value="${col.value}"
                      style="
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        border: 1px solid #cccccc;
                        margin: 0;
                      "
                    />
                  </td>
                `).join('')}
              </tr>`;
            }).join('')}
          </tbody>
        </table>
      </div>

      ${formFieldErrorHtml({ id })}

      <script>
        document.querySelectorAll("#${id} input").forEach(el => {
          el.addEventListener("change", function() {
            // Trigger validation if needed
            $(this).valid();
          });
        });
      </script>
    </div>
  `;
};
